import SVG from './SVG'

export const ShareSVG = (props) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <g className="share">
        <path
          fillRule="evenodd"
          d="M11.293 1.293a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L13 4.414V15a1 1 0 11-2 0V4.414L8.707 6.707a1 1 0 01-1.414-1.414l4-4zM4 11a1 1 0 011 1v8a1 1 0 001 1h12a1 1 0 001-1v-8a1 1 0 112 0v8a3 3 0 01-3 3H6a3 3 0 01-3-3v-8a1 1 0 011-1z"
          className="Union"
          clipRule="evenodd"
        />
      </g>
    </SVG>
  )
}
